import React from "react";
import { useTranslation } from "react-i18next";
import BluePenIcon from "../../../../assets/icons/blue-pen.svg";
import "../EditCategoryActionsModal/EditCategoryActionsModal.less";

export type EditScriptActionsModalProps = {
  name: string;
  onClose: () => void;
  onRequestDelete?: (name: string) => void;
  onRequestEditScript?: (name: string) => void;
  onRequestReorder?: (name: string) => void;
};

const EditScriptActionsModal: React.FC<EditScriptActionsModalProps> = ({ name, onClose, onRequestDelete, onRequestEditScript, onRequestReorder }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => onClose?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  return (
    <div className="edit-category-actions-bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="edit-category-actions-bottom-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="edit-category-actions-bottom-modal-container">
          <img src={BluePenIcon} className="edit-category-actions-bottom-modal-icon" alt="Edit" />
          <div className="edit-category-actions-bottom-modal-title">{t("edit-script-actions-title")}</div>
          <div className="edit-category-actions-bottom-modal-desc">{t("edit-category-actions-desc")}</div>

          <button
            type="button"
            className="edit-category-actions-button"
            onClick={() => {
              onClose?.();
              onRequestEditScript?.(name);
            }}
          >
            {t("edit-script-actions-edit")}
          </button>
          <button
            type="button"
            className="edit-category-actions-button"
            onClick={() => {
              onClose?.();
              onRequestReorder?.(name);
            }}
          >
            {t("edit-script-actions-reorder")}
          </button>
          <button
            type="button"
            className="edit-category-actions-button"
            onClick={() => {
              onClose?.();
              onRequestDelete?.(name);
            }}
          >
            {t("edit-category-actions-delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditScriptActionsModal;
